"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSpec = exports.BaseSpecSchema = exports.CardinalitySchema = exports.SchemaValidation = exports.VisibilitySchema = exports.VersionSchema = exports.AttributeSchema = exports.CommonAttributes = exports.isCommonAttribute = exports.attributeIsText = exports.TypeOfAttribute = exports.Cardinality = exports.Visibility = exports.UPDATED_AT_FIELD = exports.CREATED_AT_FIELD = exports.ID_FIELD = void 0;
var ajv_1 = __importDefault(require("ajv"));
exports.ID_FIELD = "id";
exports.CREATED_AT_FIELD = "created_at";
exports.UPDATED_AT_FIELD = "updated_at";
// Define auxiliary methods
var regexOr = function (keys) {
    return "(" + keys.map(function (s) { return "^" + s + "$"; }).join("|") + ")";
};
// Define types
var Visibility;
(function (Visibility) {
    Visibility["Global"] = "Global";
    Visibility["Tenant"] = "Tenant";
    Visibility["User"] = "User";
})(Visibility = exports.Visibility || (exports.Visibility = {}));
var Cardinality;
(function (Cardinality) {
    Cardinality["OneToMany"] = "OneToMany";
    Cardinality["ManyToMany"] = "ManyToMany";
})(Cardinality = exports.Cardinality || (exports.Cardinality = {}));
var TypeOfAttribute;
(function (TypeOfAttribute) {
    TypeOfAttribute["String"] = "string";
    TypeOfAttribute["Integer"] = "integer";
    TypeOfAttribute["Real"] = "real";
    TypeOfAttribute["Bool"] = "bool";
    TypeOfAttribute["Timestamp"] = "timestamp";
})(TypeOfAttribute = exports.TypeOfAttribute || (exports.TypeOfAttribute = {}));
exports.attributeIsText = function (a) {
    return a.type === TypeOfAttribute.String;
};
exports.isCommonAttribute = function (id) {
    return id === exports.ID_FIELD || id === exports.CREATED_AT_FIELD || id === exports.UPDATED_AT_FIELD;
};
exports.CommonAttributes = [
    {
        id: exports.ID_FIELD,
        name: "ID",
        description: "Database unique identifier",
        required: true,
        unique: true,
        type: TypeOfAttribute.Integer,
    },
    {
        id: exports.CREATED_AT_FIELD,
        name: "Created At",
        description: "Database creation timestamp",
        required: false,
        unique: false,
        type: TypeOfAttribute.Timestamp,
    },
    {
        id: exports.UPDATED_AT_FIELD,
        name: "Updated At",
        description: "Database update timestamp",
        required: false,
        unique: false,
        type: TypeOfAttribute.Timestamp,
    },
];
// Define schemas in json-schema format
exports.AttributeSchema = {
    type: "object",
    properties: {
        id: { type: "string" },
        name: { type: "string" },
        description: { type: "string" },
        required: { type: "boolean" },
        unique: { type: "boolean" },
        type: {
            type: "string",
            pattern: regexOr(Object.values(TypeOfAttribute)),
        },
    },
    required: ["id", "name", "type"],
};
exports.VersionSchema = {
    type: "string",
    pattern: "^(([0-9]+)\\.([0-9]+)\\.([0-9]+))$",
};
exports.VisibilitySchema = {
    type: "string",
    pattern: regexOr(Object.values(Visibility)),
};
exports.SchemaValidation = {
    type: "object",
    properties: {
        type: {
            type: "string",
            pattern: "(yup|json-schema)",
        },
        schema: { type: "object" },
    },
    required: ["type", "schema"],
};
exports.CardinalitySchema = {
    type: "string",
    pattern: regexOr(Object.values(Cardinality)),
};
exports.BaseSpecSchema = {
    type: "object",
    properties: {
        id: { type: "integer" },
        urn: { type: "string" },
        name: { type: "string" },
        description: { type: "string" },
        attributes: { type: "array", items: exports.AttributeSchema },
        visibility: exports.VisibilitySchema,
        schema: { type: "object" },
    },
    required: [
        "id",
        "urn",
        "name",
        "description",
        "attributes",
        "visibility",
        "schema",
    ],
};
var ajv = new ajv_1.default();
// Base class for EntitySpec/RelationSpec
var BaseSpec = /** @class */ (function () {
    function BaseSpec(inner) {
        var _this = this;
        this.getId = function () { return _this.inner.id; };
        this.getUrn = function () { return _this.inner.urn; };
        this.getName = function () { return _this.inner.name; };
        this.getDescription = function () { return _this.inner.description; };
        this.getCustomAttributes = function () { return _this.inner.attributes; };
        this.getNaturalKey = function () {
            var firstUnique = _this.inner.attributes.find(function (o) { return o.unique; });
            return firstUnique ? firstUnique.id : exports.ID_FIELD;
        };
        this.getTextAttributes = function () {
            return _this.inner.attributes.filter(exports.attributeIsText);
        };
        this.getAttributesWithId = function () { return __spreadArrays([
            exports.ID_FIELD
        ], _this.inner.attributes.map(function (a) { return a.id; })); };
        this.getSchema = function () { return _this.inner.schema; };
        this.findAttributeById = function (id) { return _this.attributeById.get(id); };
        // Basic conversion to string.
        this.toString = function () { return JSON.stringify(_this.inner, null, 2); };
        // Validate but don't throw exception
        this.validateWithErrors = function (objects) {
            var valid = _this.validateArray(objects);
            if (!valid) {
                return Object.assign([], _this.validateArray.errors);
            }
            return undefined;
        };
        // Throw exception on failed validation of array of entity/relation objects
        this.validate = function (objects) {
            var errors = _this.validateWithErrors(objects);
            if (errors) {
                throw new Error("bad object: ( " + JSON.stringify(objects) + " ): " +
                    JSON.stringify(errors));
            }
        };
        this.inner = inner;
        // Create schema validators for this entity/relation
        this.validateArray = ajv.compile({
            type: "array",
            items: this.inner.schema,
        });
        this.attributeById = new Map(__spreadArrays(inner.attributes, exports.CommonAttributes).map(function (a) { return [a.id, a]; }));
    }
    return BaseSpec;
}());
exports.BaseSpec = BaseSpec;
